import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import WhatsAppButton from '../ui/WhatsAppButton'
import ScrollToTop from '../utils/ScrollToTop'
import YoutubeSpot from '../sections/YoutubeSpot'

const PATH_TO_PAGE = {
  '/': 'home',
  '/about': 'about',
  '/services': 'services',
  '/team': 'team',
  '/contact': 'contact',
  '/blog': 'blog',
  '/forum': 'forum',
  '/store': 'store',
  '/faq': 'faq',
  '/testimonials': 'testimonials',
  '/coverage': 'coverage'
}

function Layout() {
  const { pathname } = useLocation()
  const currentPage = PATH_TO_PAGE[pathname] || null

  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Header />
      {currentPage && <YoutubeSpot position="top" currentPage={currentPage} />}
      <main className="flex-grow">
        <Outlet />
      </main>
      {currentPage && <YoutubeSpot position="bottom" currentPage={currentPage} />}
      <Footer />
      <WhatsAppButton />
    </div>
  )
}

export default Layout